import React from 'react';
import { ICollectionPaymentDetailProps } from './collection-payment-detail.types';
import * as S from '../claim-timeline.styles';
import * as Card from './timeline-detail-card.styles';
import { TextRow, DateRow, AmountRow, BooleanRow } from '../timeline-row-components';

export const CollectionPaymentDetail: React.FunctionComponent<ICollectionPaymentDetailProps> = (
    props: ICollectionPaymentDetailProps
): React.ReactElement => {
    const { payment, appType } = props;

    const renderProviderFields = () => (
        <>
            <TextRow label="ID" value={payment.id} />
            <AmountRow label="Collected Amount" value={payment.collectedAmount} />
            <TextRow label="Source" value={payment.source} />
            <DateRow label="Payment Date" value={payment.paymentDate} />
            <BooleanRow label="Manual" value={payment.manual} />
            <TextRow label="Memo" value={payment.memo} />
            <AmountRow label="Refunded Amount" value={payment.refundedAmount} />
        </>
    );

    const renderSupportFields = () => {
        const supportPayment = payment as any;

        return (
            <>
                <TextRow label="ID" value={payment.id} />
                <AmountRow label="Collected Amount" value={payment.collectedAmount} />
                <TextRow label="Source" value={payment.source} />
                <DateRow label="Payment Date" value={payment.paymentDate} />
                <BooleanRow label="Manual" value={payment.manual} />
                <TextRow label="Memo" value={payment.memo} />
                <TextRow label="Created by" value={supportPayment.createdByName} />
            </>
        );
    };

    return (
        <Card.CdPanel $embedded key={payment.id}>
            <Card.CdSectionCard $embedded>
                <S.ExpandTable>
                    <S.ExpandTBody>
                        {appType === 'provider' ? renderProviderFields() : renderSupportFields()}
                    </S.ExpandTBody>
                </S.ExpandTable>
            </Card.CdSectionCard>
        </Card.CdPanel>
    );
};
